<template>
  <v-container fluid class="gopages-container pa-0">
    <!-- Modern Header -->
    <div v-if="showHeader" class="header-section mb-6">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-web</v-icon>
        </div>
        <div class="flex-grow-1">
          <h1 class="page-title mb-1">GoPages</h1>
          <p class="page-subtitle mb-0">
            Create custom landing pages for lead generation
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="gopages-chips-container">
          <v-chip
            class="gopages-chip white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-file-document</v-icon>
            Forms
          </v-chip>
          <v-chip
            class="gopages-chip white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-link-variant</v-icon>
            Landing Pages
          </v-chip>
          <v-chip
            class="gopages-chip white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-account-multiple</v-icon>
            Lead Gen
          </v-chip>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <v-row class="ma-0 px-3">
      <!-- Form Preview Column -->
      <v-col cols="12" md="8">
        <v-card class="modern-card customBorderRadius" elevation="0">
          <div class="card-header">
            <div class="d-flex align-center">
              <div class="icon-badge mr-3">
                <v-icon color="#FFFFFF">mdi-eye</v-icon>
              </div>
              <div>
                <h3 class="card-title mb-0">Form Preview</h3>
                <p class="card-subtitle mb-0">Customize your landing page</p>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <Htmlcontainer
              :html-data="htmlData"
              :is-updated="isUpdated"
              :set-value="setValue"
              :set-options="setOptions"
              :item-nameand-color="itemNameandColor"
            ></Htmlcontainer>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Link & Settings Column -->
      <v-col cols="12" md="4">
        <!-- Link Card -->
        <v-card
          v-if="formId && formId.length"
          class="modern-card customBorderRadius mb-4"
          elevation="0"
        >
          <div class="card-header">
            <div class="d-flex align-center">
              <div class="icon-badge mr-3">
                <v-icon color="#FFFFFF">mdi-link</v-icon>
              </div>
              <div>
                <h3 class="card-title mb-0">Page Link</h3>
                <p class="card-subtitle mb-0">Share your landing page</p>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <v-text-field
              v-model="gopageLink"
              disabled
              label="Webpage Link"
              type="text"
              outlined
              dense
              class="mb-3 customBorderRadius"
              prepend-inner-icon="mdi-link"
            ></v-text-field>
            <v-btn
              color="primary"
              depressed
              block
              style="border-radius: 8px;"
              @click="copyText"
            >
              <v-icon left>mdi-content-copy</v-icon>
              Copy Link
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Htmlcontainer from "../components/Htmlcontainer.vue";
export default {
  components: { Htmlcontainer },
  props: ["itemNameandColor"],
  data() {
    return {
      showHeader: false,
      htmlData: {
        highlightItems: [
          {
            icon: "check",
            text: "Know how it works.",
          },
          {
            icon: "check",
            text: "What are the key benefits of company name",
          },
        ],
        title: "Welcome to company name",
        subHeading:
          "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages",
        submitButtonText: "Submit",
        termsAndConditionsUrl: "",
        privacyPolicyUrl: "",
        nameEnabled: true,
        emailEnabled: true,
        phoneEnabled: true,
        addressEnabled: false,
        companyNameEnabled: false,
        nameInputText: "What is your full name?",
        emailInputText: "What is your email id?",
        contactInputText: "What is your contact number?",
        addressInputText: "What is your address?",
        companyInputText: "What is your company name?",
        formTitle: "Fill in the details",
        declarationTextOne: "I have read and agreed to the following",
        declarationTextTwo: "Terms and Conditions",
        declarationTextThree: "and",
        declarationTextFour: "Privacy Policy",
        logoLink: "",
        backgroundLink: "",
        themeColor: "",
      },
      isUpdated: false,
      formId: "",
      gopageLink: "",
    };
  },
  // computed: {
  //   companyDetails() {
  //     return this.$store.getters.companyDetails;
  //   },
  //   computeLogo() {
  //     return require("../assets/logo.png");
  //   },
  // },
  mounted() {
    this.showHeader = localStorage.getItem("gopagesHeaderDismissed") !== "true";
    console.log("itemNameandColor ............", this.itemNameandColor);

    if (this.itemNameandColor && this.itemNameandColor.themeColor) {
      this.htmlData.themeColor = this.itemNameandColor.themeColor;
    }

    this.formId = this.$route.params.id;
    if (this.formId) {
      this.$http
        .get(`${this.$store.state.ENDPOINT}/integrateForms/${this.formId}`)
        .then((res) => {
          console.log("Response 1111111111111111111111111111111111", res);

          // setting the details of the form
          this.htmlData.highlightItems = res.body.content[0].highlightItems;
          this.htmlData.title = res.body.content[0].title;
          this.htmlData.subHeading = res.body.content[0].subHeading;
          this.htmlData.submitButtonText =
            res.body.formField[0].submitButtonText;
          this.htmlData.nameInputText = res.body.formField[0].nameInputText;
          this.htmlData.emailInputText = res.body.formField[0].emailInputText;
          this.htmlData.contactInputText =
            res.body.formField[0].contactInputText;
          this.htmlData.addressInputText =
            res.body.formField[0].addressInputText;
          this.htmlData.companyInputText =
            res.body.formField[0].companyInputText;
          this.htmlData.nameEnabled = res.body.formField[0].nameEnabled;
          this.htmlData.formTitle = res.body.formField[0].formTitle;
          this.htmlData.declarationTextOne =
            res.body.formField[0].declarationTextOne;
          this.htmlData.declarationTextTwo =
            res.body.formField[0].declarationTextTwo;
          this.htmlData.declarationTextThree =
            res.body.formField[0].declarationTextThree;
          this.htmlData.declarationTextFour =
            res.body.formField[0].declarationTextFour;
          this.htmlData.logoLink = res.body.logoLink ? res.body.logoLink : "";
          this.htmlData.backgroundLink = res.body.backgroundLink
            ? res.body.backgroundLink
            : "";

          // console.log("this.htmlData.nameEnabled", this.htmlData.nameEnabled)

          this.htmlData.emailEnabled = res.body.formField[0].emailEnabled;
          this.htmlData.phoneEnabled = res.body.formField[0].phoneEnabled;
          this.htmlData.companyNameEnabled =
            res.body.formField[0].companyNameEnabled;
          this.htmlData.addressEnabled = res.body.formField[0].addressEnabled;
          this.htmlData.themeColor = res.body.themeColor
            ? res.body.themeColor
            : "";
          this.gopageLink = `https://enterprise.godial.cc/gopages/${res.body.name}`;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        }); //if error occurs
    }
    // else {
    //   window.history.back();
    // }
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("gopagesHeaderDismissed", "true");
    },
    // scrollToTop() {
    //   window.scrollTo(0, 0);
    // },
    copyText() {
      navigator.clipboard.writeText(this.gopageLink);
    },
    handleChange() {
      // console.log("updated data", this.htmlData);
      this.isUpdated = true;
    },
    setValue(input, value) {
      switch (input) {
        case "Company Name":
          this.htmlData.title = value;
          break;
        case "Description":
          this.htmlData.subHeading = value;
          break;

        case "Items":
          this.htmlData.highlightItems = value;
          break;

        default:
          break;
      }
    },
    setOptions(data) {
      console.log("data", data);

      this.htmlData = { ...this.htmlData, data };
    },
    addItems(value) {
      this.htmlData.highlightItems.push = value;
    },
  },
};
</script>

<style scoped>
.gopages-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: auto;
  padding-bottom: 24px;
}

.theme--dark .gopages-container {
  background-color: #121212 !important;
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 32px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.gopages-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.gopages-chip {
  min-width: 200px !important;
  flex: 0 1 auto;
}

.modern-card {
  background: var(--v-background-base, white);
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  height: auto;
}

.theme--dark .modern-card {
  background: #1e1e1e !important;
  border-color: #333333 !important;
}

.modern-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.customBorderRadius {
  border-radius: 12px !important;
  overflow: visible !important;
}

.card-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
}

.icon-badge {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.card-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

@media (max-width: 960px) {
  .header-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .page-title {
    font-size: 28px;
  }
}
</style>
